<script setup lang="ts">
/**
 * Share Certificate (Transfer) — 양수인(신규 보유자) 1명당 주권 1부.
 * index(1-based)로 해당 transfer 행에 바인딩 → 양수인이 여러 명이면 각각 렌더.
 * cert_no / no_of_shares / shares_numeral / shares_words / member_name 은 양도 표(New Cert · New Shares · Transferee)
 * 에서 자동 매핑(읽기전용). share_class 는 편집. company / registered_office / issue_date / Signers 는 전 주권 공유.
 */
import TransferDocVarField from './TransferDocVarField.vue';
import TransferSigners from './parts/TransferSigners.vue';

const props = defineProps<{ index: number }>();
const k = (field: string) => `sc_${props.index}_${field}`;
</script>

<template>
  <div class="allot-doc sc-cert">
    <table class="sc-top">
      <tbody>
        <tr>
          <td class="sc-topcell"><div class="sc-toplbl">Certificate No.</div><TransferDocVarField :field-key="k('cert_no')" /></td>
          <td class="sc-topcell"><div class="sc-toplbl">No. of Shares</div><TransferDocVarField :field-key="k('no_of_shares')" /></td>
        </tr>
      </tbody>
    </table>

    <div class="sc-head">
      <div class="doc-company"><TransferDocVarField field-key="company_name" /></div>
      <div class="doc-meta">(the "Company") (Company Registration No. <TransferDocVarField field-key="company_registration_no" />)</div>
      <div class="doc-meta italic">Incorporated in Malaysia under the Companies Act 2016</div>
      <div class="doc-meta">REGISTERED OFFICE: <TransferDocVarField field-key="registered_office_address" /></div>
    </div>

    <p class="doc-p sc-body">
      This is to certify that <TransferDocVarField :field-key="k('member_name')" /> is the Registered Holder of
      <TransferDocVarField :field-key="k('shares_numeral')" /> (<TransferDocVarField :field-key="k('shares_words')" />)
      <TransferDocVarField :field-key="k('share_class')" /> Shares fully paid in <TransferDocVarField field-key="company_name" />
      subject to the Constitution of the Company.
    </p>

    <p class="doc-p">Issued by the Company on <TransferDocVarField field-key="issue_date" />.</p>

    <div class="sc-signers">
      <TransferSigners var-key="share_cert" board-label="Given under the Common Seal / by the Director and Secretary of the Company" />
    </div>

    <p class="doc-attn">
      NOTE: No transfer of any portion of the shares comprised in this Certificate will be registered unless accompanied by this Certificate.
    </p>
  </div>
</template>

<style scoped>
.sc-cert { border: 3px double #7a6a3a; padding: 20px 24px; background: #fffdf7; min-height: 240mm; }
.sc-top { width: 100%; border-collapse: collapse; margin-bottom: 14px; }
.sc-topcell { width: 50%; border: 1px solid #b8ac86; padding: 6px 10px; vertical-align: top; }
.sc-toplbl { font-size: 10px; font-weight: 700; color: #7a6a3a; margin-bottom: 2px; }
.sc-head { text-align: center; margin: 8px 0 16px; }
.sc-head .doc-company { font-size: 18px; font-weight: 800; letter-spacing: .03em; }
.sc-head .doc-meta { font-size: 11px; color: #333; margin-top: 2px; }
.sc-head .doc-meta.italic { font-style: italic; }
.sc-body { line-height: 2; }
.sc-signers { margin-top: 26px; }
</style>
